__webpack_require__.p = "/chatzy/";